export default __webpack_public_path__ + "static/media/logo-text.5e527fb0.png";